module.exports = __webpack_public_path__ + "static/media/header-2.0ecf1ac3.jpg";